import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebstormComponent } from './simple-icons-webstorm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebstormComponent ],
    exports:      [ SimpleIconsWebstormComponent ],
    bootstrap:    []
})
export class SimpleIconsWebstormModule {}
